var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_2372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4829 10.0898C8.07693 11.1828 8.64948 12.287 9.20055 13.4023C9.2763 13.5483 9.3487 13.6144 9.52183 13.6118C9.7123 13.6112 9.94652 13.4952 10.0964 13.3847C10.2956 13.2433 10.4922 13.0651 10.6123 12.8447C10.6861 12.7137 10.8212 12.4801 10.7432 12.3297C10.1564 11.1349 9.54149 9.94911 8.90306 8.78099C8.83622 8.6521 8.5576 8.693 8.46276 8.72037C8.24715 8.77766 8.01992 8.9282 7.86192 9.07555C7.60366 9.32395 7.27397 9.71842 7.47415 10.0834L7.4829 10.0898Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1817 7.22768L13.8187 10.5002C13.8944 10.6463 13.9668 10.7123 14.1399 10.7097C14.3304 10.7091 14.5646 10.5931 14.7145 10.4827C14.9137 10.3412 15.1103 10.163 15.2304 9.94259C15.2999 9.81386 15.4393 9.57804 15.3613 9.42767L13.7244 6.15516C13.6486 6.00908 13.5762 5.94305 13.4031 5.9456C13.2126 5.94624 12.9784 6.06224 12.8285 6.17268C12.6293 6.31414 12.4328 6.49237 12.3126 6.71275C12.2431 6.84149 12.1037 7.07731 12.1817 7.22768V7.22768Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68914 23.3242C9.30542 24.7472 13.3429 24.4908 16.9105 23.0551C20.4782 21.6194 23.7248 18.6603 25.8045 15.2486C26.9964 13.2894 27.8459 11.1535 28.3998 8.93101C28.5182 8.44441 27.8788 8.53608 27.6295 8.65447C27.1758 8.86245 26.8076 9.2878 26.687 9.77011C25.8576 13.1222 24.1692 16.3528 21.6458 18.7407C19.1225 21.1285 16.0142 22.4514 12.6513 22.6524C10.7114 22.7697 8.78934 22.4798 6.97801 21.7727C6.33579 21.5224 4.95987 23.0427 5.68485 23.3264L5.68914 23.3242V23.3242Z",
    fill: "#EE6666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_2372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9709,
    height: 16.9481,
    fill: "white",
    transform: "translate(0.111328 12.7568) rotate(-27.4087)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/Smiley.f7d79f53f165fd20f5a7d1d06ae16130.svg";
export { ForwardRef as ReactComponent };